import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sc-radio-list-field',
  templateUrl: './radio-list-field.component.html',
  styleUrls: ['./radio-list-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioListFieldComponent),
      multi: true
    }
  ]
})
export class RadioListFieldComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() options: any[];

  public selected: any;

  private _value: any;

  constructor() {}

  onChange = (value: any) => {};
  onTouched = () => {};

  public ngOnInit() {}

  public check(value: boolean) {
    if (!this.disabled) {
      this.writeValue(value);
    }
  }

  public writeValue(value: any) {
    this.selected = value;
    this.onChange(value);
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
